import script from "./Module.vue?vue&type=script&setup=true&lang=js"
export * from "./Module.vue?vue&type=script&setup=true&lang=js"

import "./Module.vue?vue&type=style&index=0&id=6add3aa6&lang=css"

const __exports__ = script;

export default __exports__